/*
 *
 *   reducer
 *
 */
import { produce } from "immer";

import {
  LOAD_PURCHASE_INVOICE_SUCCESS,
  LOAD_PURCHASE_INVOICE_ERROR,
  LOAD_PURCHASE_BARCODE_SUCCESS,
  LOAD_PURCHASE_BARCODE_ERROR,
  LOAD_PURCHASE_PRINT_RECEIPT_SUCCESS,
  LOAD_PURCHASE_PRINT_RECEIPT_ERROR,
  LOAD_PURCHASE_IMPORT_RAM_LIST_SUCCESS,
  LOAD_PURCHASE_IMPORT_RAM_LIST_ERROR,
  LOAD_PURCHASE_BARCODE_UPDATE_LIST_SUCCESS,
  LOAD_PURCHASE_BARCODE_UPDATE_LIST_ERROR,
  LOAD_SCAN_BARCODE_LIST_SUCCESS,
  LOAD_SCAN_BARCODE_LIST_ERROR,
  LOAD_RECORDS_VALID_CACHE,
  LOAD_PURCHASE_INVOICE_RECORDS_META_DATA_SUCCESS,
  LOAD_PURCHASE_INVOICE_RECORDS_META_DATA_ERROR,
  CREATE_PURCHASE_INVOICE_SUCCESS,
  CREATE_PURCHASE_INVOICE_ERROR,
  UPDATE_PURCHASE_INVOICE_SUCCESS,
  UPDATE_PURCHASE_INVOICE_ERROR,
  DELETE_PURCHASE_INVOICE_SUCCESS,
  DELETE_PURCHASE_INVOICE_ERROR,
  LOAD_PURCHASE_INVOICE_CATEGORY_SUCCESS,
  LOAD_PURCHASE_INVOICE_CATEGORY_ERROR,
  CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_SUCCESS,
  CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_ERROR,
  LOAD_PARTIES_TRANSACTION_SUCCESS,
  LOAD_PARTIES_TRANSACTION_ERROR,
  CREATE_PURCHASE_PARTY_VENDOR_ADDRESS_SUCCESS,
  CREATE_PURCHASE_PARTY_VENDOR_ADDRESS_ERROR,
  LOAD_PURCHASE_INVOICE_DASHBOARD_TRANSACTION_SUCCESS,
  LOAD_PURCHASE_INVOICE_DASHBOARD_TRANSACTION_ERROR,
  LOAD_PURCHASE_TOTAL_SUCCESS,
  LOAD_PURCHASE_TOTAL_ERROR,
  LOAD_TOTAL_PAID_SUCCESS,
  LOAD_TOTAL_PAID_ERROR,
  LOAD_TOTAL_UNPAID_SUCCESS,
  LOAD_TOTAL_UNPAID_ERROR,
  LOAD_PURCHASE_PARTY_VENDOR_ADDRESS_ERROR,
  LOAD_PURCHASE_PARTY_VENDOR_ADDRESS_SUCCESS,
} from "./constants";

const initialState = {
  purchase_invoice_list: [],
  purchase_barcode_list: [],
  purchase_print_receipt: [],
  import_ram_list: [],
  barcode_update_list: [],
  scan_barcode_list: [],
  dashboard_transactions: [],
  purchase_total_list: [],
  total_paid_list: [],
  total_unpaid_list: [],
  parties_collect_list: [],
  parties_pay_list: [],
  category_list: [],
  party_address_list: [],
  parties_transaction_list: [],
  record: {},
  records: {},
  recordsMetaData: {},
  loading: false,
  error: false,
  success: false,
  lastUpdate: null,
};

const Reducer = (
  state = initialState,
  {
    type,
    purchase_invoice_list,
    purchase_barcode_list,
    import_ram_list,
    barcode_update_list,
    scan_barcode_list,
    purchase_print_receipt,
    dashboard_transactions,
    purchase_total_list,
    total_paid_list,
    total_unpaid_list,
    party_address_list,
    category_list,
    parties_transaction_list,
    record,
    recordsMetaData = {},
    error,
    success,
  }
) => {
  return produce(state, (draft) => {
    switch (type) {
      case LOAD_RECORDS_VALID_CACHE:
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PURCHASE_INVOICE_SUCCESS:
        draft.purchase_invoice_list = purchase_invoice_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PURCHASE_PRINT_RECEIPT_SUCCESS:
        draft.purchase_print_receipt = purchase_print_receipt;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PURCHASE_IMPORT_RAM_LIST_SUCCESS:
        draft.import_ram_list = import_ram_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PURCHASE_BARCODE_UPDATE_LIST_SUCCESS:
        draft.barcode_update_list = barcode_update_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_SCAN_BARCODE_LIST_SUCCESS:
        draft.scan_barcode_list = scan_barcode_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PURCHASE_BARCODE_SUCCESS:
        draft.purchase_barcode_list = purchase_barcode_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PURCHASE_INVOICE_DASHBOARD_TRANSACTION_SUCCESS:
        draft.dashboard_transactions = dashboard_transactions;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PURCHASE_TOTAL_SUCCESS:
        draft.purchase_total_list = purchase_total_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_TOTAL_PAID_SUCCESS:
        draft.total_paid_list = total_paid_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_TOTAL_UNPAID_SUCCESS:
        draft.total_unpaid_list = total_unpaid_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PURCHASE_PARTY_VENDOR_ADDRESS_SUCCESS:
        draft.party_address_list = party_address_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PURCHASE_INVOICE_CATEGORY_SUCCESS:
        draft.category_list = category_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case LOAD_PARTIES_TRANSACTION_SUCCESS:
        draft.parties_transaction_list = parties_transaction_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case CREATE_PURCHASE_INVOICE_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case CREATE_PURCHASE_PARTY_VENDOR_ADDRESS_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case UPDATE_PURCHASE_INVOICE_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.error = false;
        draft.success = success;
        break;
      case DELETE_PURCHASE_INVOICE_SUCCESS:
        draft.record = record;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_PURCHASE_INVOICE_RECORDS_META_DATA_SUCCESS:
        draft.recordsMetaData = recordsMetaData;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_PURCHASE_INVOICE_ERROR:
      case LOAD_PURCHASE_BARCODE_ERROR:
      case LOAD_PURCHASE_INVOICE_CATEGORY_ERROR:
      case CREATE_PURCHASE_PARTY_VENDOR_ADDRESS_ERROR:
      case LOAD_PURCHASE_PARTY_VENDOR_ADDRESS_ERROR:
      case CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_ERROR:
      case LOAD_PARTIES_TRANSACTION_ERROR:
      case LOAD_PURCHASE_INVOICE_DASHBOARD_TRANSACTION_ERROR:
      case LOAD_PURCHASE_TOTAL_ERROR:
      case LOAD_TOTAL_UNPAID_ERROR:
      case LOAD_TOTAL_PAID_ERROR:
      case CREATE_PURCHASE_INVOICE_ERROR:
      case UPDATE_PURCHASE_INVOICE_ERROR:
      case DELETE_PURCHASE_INVOICE_ERROR:
      case LOAD_PURCHASE_PRINT_RECEIPT_ERROR:
      case LOAD_PURCHASE_IMPORT_RAM_LIST_ERROR:
      case LOAD_PURCHASE_BARCODE_UPDATE_LIST_ERROR:
      case LOAD_SCAN_BARCODE_LIST_ERROR:
        draft.loading = false;
        draft.error = error;
        draft.success = false;
        break;

      case LOAD_PURCHASE_INVOICE_RECORDS_META_DATA_ERROR:
        draft.error = error;
        draft.success = false;
        break;
      default:
        return state;
    }
  });
};

export default Reducer;
